module.exports = __webpack_public_path__ + "img/table_help.b652bcc6.png";